/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeaturemenuscan3Inputs */

const en_aifeaturemenuscan3 = /** @type {(inputs: Aifeaturemenuscan3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu scan`)
};

const de_aifeaturemenuscan3 = /** @type {(inputs: Aifeaturemenuscan3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte einlesen`)
};

/**
* | output |
* | --- |
* | "Menu scan" |
*
* @param {Aifeaturemenuscan3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeaturemenuscan3 = /** @type {((inputs?: Aifeaturemenuscan3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeaturemenuscan3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeaturemenuscan3(inputs)
	return de_aifeaturemenuscan3(inputs)
});
export { aifeaturemenuscan3 as "aiFeatureMenuScan" }